import { useEffect, useState } from 'react';

const useCurrentFullUrl = (): string => {
  const [fullUrl, setFullUrl] = useState<string>('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setFullUrl(window.location.href);

      const handleLocationChange = () => {
        setFullUrl(window.location.href);
      };

      const urlCheckInterval = setInterval(handleLocationChange, 100);

      return () => {
        clearInterval(urlCheckInterval);
      };
    }
  }, []);

  return fullUrl;
};

export default useCurrentFullUrl;
